import {
  Switch,
  Route,
  Link,
  useLocation
} from "react-router-dom";
import './style.scss'
import HomePage from './Home';
import PartnerPage from './Partner';
import FooterComponent from './Footer';
import { LangugageContext } from "./LanguageContext";
import React, { useState, useEffect } from "react";
import LocalizedStrings from "react-localization";
import { Container, Dropdown, Icon, Image, Menu, Loader, Sidebar } from 'semantic-ui-react';
import basicTranslation from './translations.json'
import logo from './assets/images/svg/se_white.svg'
import { toast, ToastContainer } from "react-toastify";
import NotFoundPage from "./NotFound";

function App() {
  let location = useLocation();

  let rawString = {
    en: {},
    id: {},
    vi: {},
    km: {}
  }

  const stringTrans = new LocalizedStrings(basicTranslation)

  const [translation, setTranslation] = useState(stringTrans)
  const [loading, setLoading] = useState(true)
  const [loadingEvent, setLoadingEvent] = useState(true)
  const [loadingInstaller, setLoadingInstaller] = useState(true)
  const [rawTrans, setRawTrans] = useState(null)
  const [event, setEvent] = useState(null)
  const [pcFile, setPCFile] = useState('')
  const savedLang = localStorage.getItem('language')
  const [lang, setLang] = useState(savedLang!==null ? savedLang : 'en')
  const [activeMenu, setActiveMenu] = useState('')
  const [visibleMenu, setVisibleMenu] = useState(false)

  useEffect(() => {
    loadTranslation()
    loadEvent()
    loadInstaller()
    setActiveMenu('')
    return () => true
  }, [location]) // eslint-disable-line react-hooks/exhaustive-deps

  const loadTranslation = () =>{
    fetch(process.env.REACT_APP_LOCALIZY_URL+'v1/api/translation?project_id=P-Z1JH')
    .then((res)=>{
      return res.json()
    })
    .then((res)=>{
      let temp = basicTranslation
      let data = res.data
      rawString.en = {...temp.en, ...data.en}
      rawString.id = {...temp.id, ...data.id}
      rawString.vi = {...temp.vi, ...data.vi}
      rawString.km = {...temp.km, ...data.km}

      stringTrans.setContent(rawString)
      let savedLang = localStorage.getItem('language')
      if(savedLang !== null){
        if(savedLang !== "en"){
          stringTrans.setLanguage(savedLang)
        }
      }
      setTranslation(stringTrans)
      setLoading(false)
      setRawTrans(rawString)
    })
    .catch((e)=>{
      toast.error('Something wrong on fetching translation, please contact developer.')
    })
  }

  const loadEvent = () =>{
    fetch(process.env.REACT_APP_DOC_URL+'challenge_period.php')
    .then((res)=>{
        return res.json()
    })
    .then((res)=>{
      setEvent(res)
      setLoadingEvent(false)
    })
    .catch((e)=>{
      toast.error('Something wrong on fetching event data, please contact developer.')
    })
  }

  const loadInstaller = () =>{
    fetch(process.env.REACT_APP_CRM_URL+'public/installer?type=new&lang=en')
    .then((res)=>{
        return res.json()
    })
    .then((res)=>{
      setPCFile(res.installer.pc.file)
      setLoadingInstaller(false)
    })
    .catch((e)=>{
      toast.error('Something wrong on fetching installer data, please contact developer.')
    })
  }

  const changeLang = (param) =>{
    stringTrans.setContent(rawTrans)
    stringTrans.setLanguage(param)
    setTranslation(stringTrans)
  }

  const onChangeLang = (e, data) =>{
      setLang(data.value)
      changeLang(data.value)
      localStorage.setItem('language', data.value)
  }

  const goToTarget = (param, e) =>{
      document.getElementById(param).scrollIntoView({
          behavior: 'smooth'
      });
      setActiveMenu(param)
      disableScroll(false)
  }

  const disableScroll = (param) =>{
    setVisibleMenu(param)
    if(param){
      document.body.style.overflow = 'hidden';
    }else{
      document.body.style.overflow = 'auto';
    }
  }

  return (
    <>
      {loading || loadingEvent || loadingInstaller ? <Loader active/> : 
        <LangugageContext.Provider value={{translation, changeLang}}>
          <Sidebar.Pushable>
            <Sidebar
              as={Menu}
              className="borderless"
              animation="push"
              inverted
              onHide={() => disableScroll(false)}
              vertical
              visible={visibleMenu}
            >
              <Container>
                {!location.pathname.includes('partner') ? 
                <>
                <Menu.Item link onClick={goToTarget.bind(null, 'home_banner')}>
                  <Image className="logo" src={logo} size="tiny"/>
                </Menu.Item>
                <Menu.Item link onClick={goToTarget.bind(null, 'home_hof')} active={activeMenu === 'home_hof'}>HoF</Menu.Item>
                <Menu.Item link onClick={goToTarget.bind(null, 'home_leaderboard')} active={activeMenu === 'home_leaderboard'}>{translation.standings}</Menu.Item>
                <Menu.Item link onClick={goToTarget.bind(null, 'home_challenge')} active={activeMenu === 'home_challenge'}>{translation.the_challenge}</Menu.Item>
                </>
                : <>
                <Link className="item" to="/" onClick={()=>disableScroll(false)}><Image className="logo" src={logo} size="tiny"/></Link>
                <Link className="item" to="/" onClick={()=>disableScroll(false)}>{translation.weekly}</Link>
                </>}
                <Link className={location.pathname.includes('partner') ? "active item" : "item"}
                to="/partner" onClick={()=>disableScroll(false)}>{translation.partners}</Link>

                <Menu.Item>
                  <Menu.Header>{translation.download}</Menu.Header>
                  <Menu.Item>
                    <Menu.Item as="a" target="_blank" href="https://play.google.com/store/apps/details?id=com.solveedu.dawnofcivilization"><Icon name="android" color="green"/> Google Play Store</Menu.Item>
                    <Menu.Item as="a" target="_blank" href={pcFile}><Icon name="laptop" color="orange"/> PC/Laptop</Menu.Item>
                  </Menu.Item>
                </Menu.Item>
                {!location.pathname.includes('partner') ? 
                <Menu.Item link target="_blank" href={event.linkText2.includes('http') ? event.linkText2 : 'https://'+event.linkText2}>{translation.survey}</Menu.Item>
                : null}
              </Container>
            </Sidebar>
            <Sidebar.Pusher dimmed={visibleMenu}>
              {/* header start */}
              <Menu fixed="top" size="small" borderless inverted id="c_header">
                <Container>
                  {!location.pathname.includes('partner') ? 
                  <>
                  <Menu.Item link onClick={goToTarget.bind(null, 'home_banner')}>
                      <Image className="logo" src={logo}/>
                  </Menu.Item>
                  <Menu.Item link onClick={goToTarget.bind(null, 'home_hof')} active={activeMenu === 'home_hof'}>HoF</Menu.Item>
                  <Menu.Item link onClick={goToTarget.bind(null, 'home_leaderboard')} active={activeMenu === 'home_leaderboard'}>{translation.standings}</Menu.Item>
                  <Menu.Item link onClick={goToTarget.bind(null, 'home_challenge')} active={activeMenu === 'home_challenge'}>{translation.the_challenge}</Menu.Item>
                  </>                  
                  : <>
                  <Link className="item" to="/"><Image className="logo" src={logo}/></Link>
                  <Link className="item" to="/">{translation.weekly}</Link>
                  </>}
                  
                  <Link className={location.pathname.includes('partner') ? "active item" : "item"}
                  to="/partner">{translation.partners}</Link>
                  <Dropdown item trigger={<><Icon name="download" color="orange"/> {translation.download}</>}>
                      <Dropdown.Menu>
                          <Dropdown.Item as="a" target="_blank" href="https://play.google.com/store/apps/details?id=com.solveedu.dawnofcivilization"><Icon name="android" color="green"/> Google Play Store</Dropdown.Item>
                          <Dropdown.Item as="a" target="_blank" href={pcFile}><Icon name="laptop" color="orange"/> PC/Laptop</Dropdown.Item>
                      </Dropdown.Menu>
                  </Dropdown>

                  {!location.pathname.includes('partner') ? 
                  <Menu.Item link target="_blank" href={event.linkText2.includes('http') ? event.linkText2 : 'https://'+event.linkText2}
                  ><Icon name="file alternate" color="orange"/> {translation.survey}</Menu.Item>
                  : null}
                  
                  <Menu.Menu position="right">
                      <Dropdown item value={lang} options={[
                          {key: 'en', value: 'en', text: 'English', flag: 'gb'},
                          {key: 'id', value: 'id', text: 'Bahasa', flag: 'id'},
                          {key: 'vi', value: 'vi', text: 'Vietnamese', flag: 'vn'},
                          {key: 'km', value: 'km', text: 'Khamer', flag: 'kh'}
                      ]} onChange={onChangeLang}/>
                  </Menu.Menu>
                </Container>
              </Menu>
              
              {/* mobile */}
              <Menu fixed="top" borderless inverted id="c_header_mobile">
                <Menu.Item onClick={()=>disableScroll(true)}>
                  <Icon name={visibleMenu ? 'times' : 'bars'} link size="large"/>
                </Menu.Item>
                <Menu.Item link>
                  <Image className="logo" size="mini" src={logo}/>
                </Menu.Item>
                <Menu.Menu position="right">
                    <Dropdown item value={lang} options={[
                        {key: 'en', value: 'en', flag: 'gb'},
                        {key: 'id', value: 'id', flag: 'id'},
                        {key: 'vi', value: 'vi', flag: 'vn'},
                        {key: 'km', value: 'km', flag: 'kh'}
                    ]} onChange={onChangeLang}/>
                </Menu.Menu>
              </Menu>
              {/* header end */}
              
              <Switch>
                <Route exact path="/partner">
                    <PartnerPage/>
                </Route>
                <Route exact path="/">
                  <HomePage event={event} installer={pcFile}/>
                </Route>
                <Route path="*">
                  <NotFoundPage/>
                </Route>
              </Switch>

              <FooterComponent/>

            </Sidebar.Pusher>
          </Sidebar.Pushable>
        </LangugageContext.Provider>
      }

      <ToastContainer
      position="bottom-left"
      autoClose={5000}
      hideProgressBar={false}
      closeOnClick={false}
      newestOnTop
      theme="colored"
      rtl={false}
      pauseOnFocusLoss={false}
      draggable={false}
      pauseOnHover={false}
      />
    </>
  );
}

export default App;
